document.addEventListener('change', function (event) {
  var select = event.target.closest('[data-variant-select]');
  if (!select) return;

  var form = select.closest('form');
  var price = form && form.querySelector('[data-variant-price]');
  var option = select.options[select.selectedIndex];

  if (price && option && option.dataset.price) {
    price.textContent = option.dataset.price;
  }
});
